import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Hero = () => {
  return (
    <section id="hero" className="relative min-h-[50vh] md:min-h-[60vh] flex flex-col">
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900/70 via-navy-900/30 to-navy-900/80" />

      {/* Main Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-6 pt-20 pb-6">
        {/* Top: MCG Logo + Company Name */}
        <div className="flex flex-col items-center">
          {/* MCG Logo Mark */}
          <div className="mb-4 md:mb-5">
            <div className="w-16 md:w-20 h-px bg-gold-400 mx-auto mb-3" />
            <div className="font-serif font-bold text-4xl md:text-5xl lg:text-6xl tracking-[0.3em] text-gold-400 leading-none">
              MCG
            </div>
            <div className="w-16 md:w-20 h-px bg-gold-400 mx-auto mt-3" />
          </div>

          {/* Company Name */}
          <h1 className="font-serif text-sm sm:text-base md:text-xl lg:text-2xl xl:text-3xl font-bold text-cream-100 tracking-[0.12em] mb-2 leading-tight">
            MARQUEE COMMODITY GROUP
          </h1>
          <p className="font-serif text-base md:text-xl lg:text-2xl text-cream-200/70 font-medium tracking-wide">
            Canada &bull; <span className="text-gold-400">Founded by Bentley G.S. Brar</span>
          </p>
        </div>

        {/* 150px spacer */}
        <div style={{ height: '150px' }} />

        {/* Bottom: Tagline + Buttons */}
        <div className="flex flex-col items-center">
          <div className="max-w-3xl mb-6 md:mb-8">
            <p className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-cream-100 font-bold leading-snug mb-3 md:mb-4 tracking-wide">
              Independent Transaction Advisory
            </p>
            <p className="font-serif text-base md:text-lg lg:text-xl text-cream-200/80 italic tracking-wide">
              Architecting Institutional Outcomes
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 mb-8">
            <HashLink
              smooth
              to="/#services"
              className="px-8 md:px-10 py-3 bg-navy-900/70 text-gold-400 border border-gold-500/60 font-semibold tracking-[0.2em] text-xs md:text-sm hover:bg-navy-900 hover:border-gold-400 transition-all duration-300 backdrop-blur-sm"
            >
              OUR SERVICES
            </HashLink>
            <Link
              to="/contact"
              className="px-8 md:px-10 py-3 bg-navy-900/70 text-gold-400 border border-gold-500/60 font-semibold tracking-[0.2em] text-xs md:text-sm hover:bg-navy-900 hover:border-gold-400 transition-all duration-300 backdrop-blur-sm"
            >
              CONTACT US
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
